export const status = {
  ALL: 'ALL',
  WAITING: 'WAITING',
  ASSIGNED: 'ASSIGNED',
  EXPIRED: 'EXPIRED',
  PICKEDUP: 'PICKEDUP',
  DELIVERED: 'DELIVERED',
  CANCELLED: 'CANCELLED',
  BILLED: 'BILLED',
}

export const statusText = {
  ALL: 'ทั้งหมด',
  WAITING: 'รอจ่ายงาน',
  ASSIGNED: 'จ่ายงานแล้ว',
  EXPIRED: 'เลยกำหนดการ',
  PICKEDUP: 'ขึ้นของแล้ว',
  DELIVERED: 'ขนส่งเสร็จแล้ว',
  CANCELLED: 'ยกเลิกงาน',
  BILLED: 'วางบิลแล้ว',
}

export const dealType = {
  PERTRIP: 'PERTRIP',
  PERWEIGHT: 'PERWEIGHT',
}

export const dealTypeText = {
  PERTRIP: 'ต่อเที่ยว',
  PERWEIGHT: 'ต่อน้ำหนัก',
}

export const unitText = {
  TON: 'ตัน',
  KG: 'กิโลกรัม',
  H50: 'กระสอบ 50 กิโลกรัม',
  TRIP: 'เที่ยว',
}

export const unitValue = {
  TON: 'TON',
  KG: 'KG',
  H50: 'H50',
  TRIP: 'TRIP',
}

export const unit = [
  {
    value: 'TON',
    text: 'ตัน',
  }, {
    value: 'NORMALKILOGRAM',
    text: 'กิโลกรัม',
  }, {
    value: 'KILOGRAM50',
    text: 'กระสอบ 50 กิโลกรัม',
  }, {
    value: 'TRIP',
    text: 'เที่ยว',
  },
]

export const unitVar = [
  {
    value: 'TON',
    text: 'ตัน',
  }, {
    value: 'KG',
    text: 'กิโลกรัม',
  }, {
    value: 'H50',
    text: 'กระสอบ 50 กิโลกรัม',
  }, {
    value: 'TRIP',
    text: 'เที่ยว',
    disabled: true,
  },
]


export const fuelStatus = {
  ALL: 'ALL',
  NONE: 'NONE',
  WAITING: 'WAITING',
  EXPIRED: 'EXPIRED',
  FILLED: 'FILLED',
  PRINTED: 'PRINTED',
  CANCELLED: 'CANCELLED',
  BILLED: 'BILLED',
  LOST: 'LOST',
}

export const fuelStatusText = {
  ALL: 'ทั้งหมด',
  NONE: 'ยังไม่สร้าง',
  WAITING: 'รอเบิก',
  EXPIRED: 'เลยกำหนดการ',
  FILLED: 'เติมน้ำมันครบแล้ว',
  PRINTED: 'พิมพ์ใบเบิกแล้ว',
  CANCELLED: 'ยกเลิก',
  BILLED: 'ได้รับบิลแล้ว',
  LOST: 'สูญหาย',
}

export const detailMode = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
}
